import React, { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext/authContext'; // Adjust path as needed
import { dynamoDb, s3 } from '../../awsConfig'; // Use your centralized AWS config
import './QuizTime.css';

const QuizTime = () => {
  const { user } = useAuth();
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch the quiz file details from DynamoDB
  const fetchQuizFile = async () => {
    const params = {
      TableName: 'videos2', // Existing table name
      Key: {
        Date: "quizTime", // Reserved for quiz files
        Subject: "quizTime",
      },
    };

    try {
      const result = await dynamoDb.get(params).promise();
      setUploadedFile(result.Item?.fileUrl || null);
    } catch (error) {
      console.error('Error fetching quiz file:', error);
    } finally {
      setLoading(false);
    }
  };

  // Upload the file to S3 and save the URL to DynamoDB
  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) {
      alert('Please select a file first.');
      return;
    }

    const fileKey = `quiz-time/${file.name}`; // Key for S3 bucket

    try {
      // Upload file to S3
      await s3
        .upload({
          Bucket: process.env.REACT_APP_S3_BUCKET_NAME, 
          Key: fileKey,
          Body: file,
          ContentType: file.type,
          //ACL: 'public-read',
        })
        .promise();

      const fileUrl = `https://${process.env.REACT_APP_S3_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${fileKey}`;

      // Save file URL to DynamoDB
      const params = {
        TableName: 'videos2',
        Key: {
          Date: "quizTime", // Reserved for quiz files
          Subject: "quizTime",
        },
        UpdateExpression: 'set #fileUrl = :fileUrl',
        ExpressionAttributeNames: {
          '#fileUrl': 'fileUrl',
        },
        ExpressionAttributeValues: {
          ':fileUrl': fileUrl,
        },
      };

      await dynamoDb.update(params).promise();
      alert('File uploaded successfully!');
      fetchQuizFile(); // Refresh quiz file data
    } catch (error) {
      console.error('Error uploading quiz file:', error);
      alert('File upload failed.');
    }
  };

  useEffect(() => {
    fetchQuizFile();
  }, []);

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <div className ="quiz-time-bg">
    <div className="quiz-time-container">
      <h2>Quiz Time!</h2>
      {user?.role === 'Admin' || user?.role === 'Tutor' ? (
        <div className="upload-section">
          <form onSubmit={handleUpload}>
            <label>Upload Quiz File:</label>
            <input
              type="file"
              onChange={(e) => setFile(e.target.files[0])}
            />
            <button type="submit">Upload</button>
          </form>
        </div>
      ) : uploadedFile ? (
        <div className="file-preview">
          <h3>Uploaded Quiz</h3>
          <img src={uploadedFile} alt="Quiz" />
        </div>
      ) : (
        <p>No quiz has been uploaded yet.</p>
      )}
    </div>
    </div>
  );
};

export default QuizTime;
